import React from 'react';
import i18n from 'i18next';
import pick from 'lodash/pick';

import { addModal } from 'core/notifications';
import { addStylesToSchema, NewItemFormContainer } from '@/exceed';

import getEditEnrollmentSchema from '../../schemas/getEditEnrollmentSchema';

import styles from '../../styles/enrollments.module.scss';

export default async ({
  courseId,
  enrolledUsers,
  enrollmentsSelectedUsers,
  resetEnrollmentsSelectedUsers,
  selectedUsersCount,
}) => {
  const id = 'bulk-update';
  const selectedEnrollmentIds = Object.keys(enrollmentsSelectedUsers.data.users);
  const isSingleSelection = selectedUsersCount === 1;

  const { type } = await addModal({
    body: i18n.t('bulk-update-body', { count: selectedUsersCount }),
    title: isSingleSelection ? i18n.t('update-enrollment') : i18n.t('bulk-update'),
    component: (
      <NewItemFormContainer
        getAxiosConfig={(data, formState) => {
          const visibleFields = Object.keys(formState).filter(
            (fieldName) => !formState[fieldName].shouldHideField,
          );
          const filteredData = pick(data, visibleFields);

          return {
            method: 'put',
            url: '/api/admin/enrollments/bulk_update',
            data: {
              data: {
                ...filteredData,
                course_id: Number(courseId),
                enrollment_ids: selectedEnrollmentIds.map(Number),
              },
            },
          };
        }}
        id={id}
        isSubmitDisabledIfModelUnchanged
        schema={addStylesToSchema(
          getEditEnrollmentSchema({ selectedUsersCount, enrolledUsers }),
          styles,
        )}
      />
    ),
    hasCloseButton: true,
    id,
    ...(isSingleSelection && {
      model: enrolledUsers.data.enrollments.items[selectedEnrollmentIds[0]].data,
    }),
  });

  if (type === 'submit') {
    resetEnrollmentsSelectedUsers();
    enrolledUsers.refetch();
  }
};
